import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
/*import { getMesNumero, getMesNombre } from '../../mixins/helpers';*/

const state = {
    clienteId: 0,
    
    id: 0,
    cargo: '',
    nombre: '',
    telefono: '',
    email: '',
    rowVersion: null,

    contactoAdministracionDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_CONTACTO' (state, params) {
        state.id = params.id;
        state.clienteId = params.clienteId;

        state.cargo = '';
        state.nombre = '';
        state.telefono = '';
        state.email = '';
        state.rowVersion = null;
    },
    'SET_CONTACTO' (state, contacto) {
        state.cargo = contacto.cargo.toUpperCase().trim();
        state.nombre = contacto.nombre.toUpperCase().trim();
        state.telefono = contacto.telefono;
        state.email = contacto.email;
        state.rowVersion = contacto.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.contactoAdministracionDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.contactoAdministracionDatos = params.contactoAdministracionDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONTACTO', params);

            if (params.id) {
                if (params.id != 0) {
                    apiAxios.get('clientescontactosadministracion/' + params.id + '/abm' ) 
                    .then(res => {
                        commit('SET_CONTACTO', res.data);

                        resolve();
                    })
                    .catch(error =>  {
                        reject(error);
                    });
                } else {
                    resolve();    
                }
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let contacto= {
                clienteId: state.clienteId,
                cargo: state.cargo.toUpperCase().trim(),
                nombre: state.nombre.toUpperCase().trim(),
                telefono: state.telefono.toUpperCase().trim(),
                email: state.email.toLowerCase().trim(),
            }

            let url = 'clientescontactosadministracion';
            if (state.id != 0) {
                url += "/" + state.id;
                contacto.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, contacto)
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        })
    },
    delete ( { }, contactoAdministracionId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('clientescontactosadministracion/' + contactoAdministracionId + '/delete')
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        })
    },
    getDatos ( { commit }, contactoAdministracionId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (contactoAdministracionId) {
                if (contactoAdministracionId != 0) {
                    apiAxios.get('clientescontactosadministracion/' + contactoAdministracionId ) 
                    .then(res => {

                        let contactoAdministracionDatos = [
                            { 'nombre': 'cargo', 'campo': 'Cargo', 'valor': res.data.cargo, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'telefono', 'campo': 'Teléfono', 'valor': res.data.telefono, 'formato': '' },
                            { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                        ];
                        
                        let params = {
                            contactoAdministracionDatos
                        };

                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error =>  {
                        reject(error);
                    });
                }
            } 
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}